import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import { trackLead } from '../lib/pixel';
import './WaitlistSection.css';

const TIMELINES = [
  ['0-3mo', '0–3 months'],
  ['3-6mo', '3–6 months'],
  ['6-12mo', '6–12 months'],
  ['exploring', 'just exploring'],
];

const BEDROOM_OPTIONS = [1, 2, 3, 4, 5];

export default function WaitlistSection() {
  const [dismissed, setDismissed] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    firstName: '',
    email: '',
    timeline: '',
    city: '',
    state: '',
    minBedrooms: '',
  });

  if (dismissed) return null;

  function update(field, value) {
    setForm(f => ({ ...f, [field]: value }));
    setError('');
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    setError('');

    const { error: insertError } = await supabase.from('waitlist').insert({
      email: form.email.trim().toLowerCase(),
      first_name: form.firstName.trim() || null,
      timeline: form.timeline || null,
      city: form.city.trim() || null,
      state: form.state.trim().toUpperCase() || null,
      min_bedrooms: form.minBedrooms ? Number(form.minBedrooms) : null,
    });

    // 23505 = unique_violation — they're already on the list, treat as success.
    if (insertError && insertError.code !== '23505') {
      setError(insertError.message);
      setSubmitting(false);
      return;
    }

    trackLead({ content_name: 'waitlist_signup' });
    setSubmitted(true);
    setSubmitting(false);
  }

  return (
    <section className="waitlist-section">
      <div className="page">
        <div className="waitlist-card">
          {submitted ? (
            <div className="waitlist-success">
              <button className="waitlist-dismiss" onClick={() => setDismissed(true)}>✕</button>
              <div className="waitlist-success-icon">✓</div>
              <h3>you're on the list!</h3>
              <p>We'll reach out as soon as homes matching what you're looking for are ready.</p>
            </div>
          ) : (
            <>
              <div className="waitlist-intro">
                <h2 className="section-title" style={{ marginBottom: 8 }}>not ready to sign up? join the waitlist</h2>
                <p>Tell us what you're looking for and we'll let you know when it's time to bid.</p>
              </div>

              <form onSubmit={handleSubmit} className="waitlist-form">
                <div className="waitlist-row">
                  <div className="input-group">
                    <label>first name</label>
                    <input
                      type="text"
                      placeholder="Your first name"
                      value={form.firstName}
                      onChange={e => update('firstName', e.target.value)}
                      required
                    />
                  </div>
                  <div className="input-group">
                    <label>email</label>
                    <input
                      type="email"
                      placeholder="you@email.com"
                      value={form.email}
                      onChange={e => update('email', e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="waitlist-row">
                  <div className="input-group">
                    <label>timeline to buy or lease</label>
                    <select value={form.timeline} onChange={e => update('timeline', e.target.value)}>
                      <option value="">select timeline</option>
                      {TIMELINES.map(([val, label]) => (
                        <option key={val} value={val}>{label}</option>
                      ))}
                    </select>
                  </div>
                  <div className="input-group">
                    <label>minimum bedrooms</label>
                    <select value={form.minBedrooms} onChange={e => update('minBedrooms', e.target.value)}>
                      <option value="">any</option>
                      {BEDROOM_OPTIONS.map(n => <option key={n} value={n}>{n}+</option>)}
                    </select>
                  </div>
                </div>

                <div className="waitlist-row">
                  <div className="input-group">
                    <label>target city</label>
                    <input
                      type="text"
                      placeholder="Houston"
                      value={form.city}
                      onChange={e => update('city', e.target.value)}
                    />
                  </div>
                  <div className="input-group">
                    <label>state</label>
                    <input
                      type="text"
                      placeholder="TX"
                      maxLength={2}
                      value={form.state}
                      onChange={e => update('state', e.target.value)}
                    />
                  </div>
                </div>

                {error && <div className="waitlist-error">{error}</div>}

                <button type="submit" className="btn btn-primary btn-full" disabled={submitting}>
                  {submitting ? 'joining...' : 'join the waitlist'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
